import AssessmentItemsView from './AssessmentItemsView';

export default AssessmentItemsView;
